import axios from "axios";
import endPoints from "../../../../../config/endPoints";


export const getAllServicesForDeptInProvApi = async(reqBody) => {
  return axios.post(`${endPoints.services}`, reqBody);
}

export const searchServicesForDeptForProvApi = async(reqBody) => {
  return axios.post(`${endPoints.services}/search`, reqBody);
}

// export const getAllServicesForDeptApi = async(reqBody) => {
//   return axios.get(`${endPoints.services}/deptId`, reqBody);
// }

// export const searchServicesForDeptApi = async(reqBody) => {
//   return axios.post(`${endPoints.services}/search/deptId`, reqBody);
// }